import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import { isPositiveNumber } from "et3-type-guards";
import { withLiteObserverAndTheme } from "../core/et3-enhanced-render";
import getUserMessagesStore from "../stores/user-store/messages-store";
import { TUserMessagesDataCounts } from "../Types";

const KhattabatSocialMediaBadWordsCounter = withLiteObserverAndTheme<{
  socialMediaBadWordsCount: TUserMessagesDataCounts;
}>((props) => {
  const { socialMediaBadWordsCount } = props;

  return !isPositiveNumber(socialMediaBadWordsCount[0].messagesCount) ? null : (
    <Stack
      direction="row"
      spacing={1}
      flexWrap="wrap"
      useFlexGap
      justifyContent="flex-end"
    >
      {socialMediaBadWordsCount.map((wordsObject) =>
        isPositiveNumber(wordsObject.messagesCount) ? (
          <Chip
            key={wordsObject.text}
            variant="outlined"
            color={getUserMessagesStore().getBadWordsCounterColor(
              wordsObject.text
            )}
            label={`${wordsObject.text} ${wordsObject.count}/${wordsObject.messagesCount}`}
          />
        ) : null
      )}
    </Stack>
  );
});

export default KhattabatSocialMediaBadWordsCounter;
